import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import DataSource from 'devextreme/data/data_source';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { DashboardItem } from '../interfaces/dashboard-item.interface';
import { FunctionAppInfo } from '../interfaces/function-app-info.interface';
import { FunctionAppSlot } from '../interfaces/function-app-slot.interface';
import { SelectedCompanyService } from '../selected-company/selected-company.service';
import { DashboardItemService } from '../services/dashboard-item.service';
import { FunctionAppInfoService } from '../services/function-app-info.service';
import { FunctionAppService } from '../services/function-app.service';
import { LinkService } from '../services/link.service';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DxoSelectionModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxDataGridModule, DxSelectBoxModule } from 'devextreme-angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shell-functionappversioning',
    templateUrl: './functionappversioning.component.html',
    styleUrls: ['./functionappversioning.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, DxDataGridModule, DxoSelectionModule, DxiColumnModule, DxTemplateModule, DxSelectBoxModule, AsyncPipe]
})
export class FunctionappversioningComponent implements OnInit {


  constructor(private asamcoUserService: AsamcoUserService, private linkService: LinkService, private selectedCompanyService: SelectedCompanyService, private dashboardItemService: DashboardItemService, private functionappInfoService: FunctionAppInfoService) { }

  public isAdminSubject = new BehaviorSubject<boolean>(false);

  public serverListDataSource: Observable<FunctionAppSlot[]> = new Observable<FunctionAppSlot[]>();
  public companyList: Observable<any[]> = new Observable<any[]>();
  public links$: Observable<any[]> = new Observable<any[]>();


  ngOnInit(): void {
    this.asamcoUserService.isAdmin().then(result =>  {  this.isAdminSubject.next(result); this.getFunctionAppInstances(); this.getCompanies(); });
  }

  getFunctionAppInstances() {
    this.serverListDataSource = this.linkService.getFunctionAppInstances();
  }

  getCompanies() {
    //NOTE: Only works for superadmins, don't bother else
    this.companyList = this.selectedCompanyService.getCompanies();
  }

  selectCompany(event: any) {
    //console.log(event)

    this.links$ = this.dashboardItemService.getById(event.value).pipe(switchMap((dashboardItems: DashboardItem[]) => {
      const functionAppInfoArray$: Observable<FunctionAppInfo>[] = [];
      dashboardItems.forEach(item => {
        // const functionAppInfo$: Observable<any> = this.functionappInfoService.getFunctionAppInfoById(item.id).pipe(map(functionAppInfo => ({...item, functionAppSlot: functionAppInfo?.slot})))
        // functionAppInfoArray$.push(functionAppInfo$);
      })
      return forkJoin(functionAppInfoArray$)
      }))

      //dat$.subscribe(e => console.log(e))

  }

  updateLinkVersion(event, data) {
    //this.functionappInfoService.updateFunctionAppInfoById()
    // console.log(event.value);
    // console.log(data);

    //Update or create entity
    if(event.value)
    {
      this.functionappInfoService.updateFunctionAppInfoById(data, event.value).subscribe(e => console.log(e))
    }
    else //no value = delete entry from database
    {
      this.functionappInfoService.deleteFunctionAppInfoById(data).subscribe(e => console.log(e))
    }

  }



}
